import { render, staticRenderFns } from "./AsignacionTipoContrato.vue?vue&type=template&id=3c687c63"
import script from "./AsignacionTipoContrato.vue?vue&type=script&lang=js"
export * from "./AsignacionTipoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports